import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

// Components
import { SplitScreen, SplitScreenContentHolder } from './Screen';
import { ContentContainer } from './ContentContainer';

// Assets
import { brandColors, device, fonts } from '../../styles/variables';

const Wrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  height: 80px;
  width: 100%;
  background: ${brandColors.blue};
`;

const Container = ContentContainer.extend`
  padding: 0 !important;
  @media ${device.tablet} {
    margin: 0 auto;
  }
`;

const Copywrite = styled.p`
  width: 250px;
  color: ${brandColors.white};
  font-family: ${fonts.athelas};
  font-style: italic;
  letter-spacing: 1px;
  font-size: 14px;
  line-height: 34px;
  margin: 6px 0 0 0;
  @media ${device.tablet} {
    margin: 1em 0;
    font-size: 18px;
    line-height: 38px;
  }
`;

const Links = styled.p`
  color: ${brandColors.yellow};
  font-family: ${fonts.athelas};
  font-style: italic;
  letter-spacing: 1px;
  font-size: 14px;
  line-height: 34px;
  margin: 0;
  @media ${device.mobileS} {
    text-align: left;
  }
  @media ${device.tablet} {
    margin: 1em 0;
    font-size: 18px;
    line-height: 38px;
    text-align: right;
  }

  span.separator {
    cursor: default;
    color: ${brandColors.grey};
    margin: 0 6px;
    @media ${device.tablet} {
      margin: 0 26px;
    }
    @media ${device.laptop} {
      margin: 0 46px;
    }
  }
`;

const Link = styled.span`
  cursor: pointer;
`;

const StyledSplitScreen = SplitScreen.extend`
  display: block;
  height: auto;
  width: 100%;
  padding: 0 30px;
  @media ${device.tablet} {
    width: ${({ unsupported }) => (unsupported ? '100%' : '50%')};
    display: inline-block;
    vertical-align: middle;
  }
`;

const StyledSplitScreenContentHolder = SplitScreenContentHolder.extend`
  @media ${device.mobileS} {
    float: left;
  }
`;

class Footer extends React.PureComponent {
  render() {
    const { history, unsupported } = this.props;

    let toShow = (
      <StyledSplitScreen>
        <StyledSplitScreenContentHolder direction="left">
          <Links>
            <Link onClick={() => history.push('privacy')}>Privacy</Link>
            <span className="separator">|</span>
            <Link onClick={() => history.push('cookies')}>Cookies</Link>
            <span className="separator">|</span>
            <Link onClick={() => history.push('contact')}>Contact</Link>
          </Links>
        </StyledSplitScreenContentHolder>
      </StyledSplitScreen>
    );
    if (unsupported) {
      toShow = null;
    }

    return (
      <Wrapper className="footer">
        <Container>
          <StyledSplitScreen unsupported={unsupported}>
            <StyledSplitScreenContentHolder direction="right">
              <Copywrite>&copy; Radical Departures Ltd 2026</Copywrite>
            </StyledSplitScreenContentHolder>
          </StyledSplitScreen>
          {toShow}
        </Container>
      </Wrapper>
    );
  }
}

Footer.defaultProps = {
  unsupported: false
};

Footer.propTypes = {
  history: PropTypes.any.isRequired,
  unsupported: PropTypes.bool
};

export default withRouter(connect()(Footer));



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.jsx